import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'app-grid-card',
  templateUrl: './grid-card.component.html',
  styleUrls: ['./grid-card.component.scss', './grid-card.component.en.scss']
})
export class GridCardComponent {
  @Input() open: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() modalTitle!: string;
  @HostBinding('class.mobile-modal') @Input() mobileModal: boolean = false;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  close() {
    this.closeModal.emit();
  }
}
